import {ChangeDetectorRef, Component, OnInit} from '@angular/core';
import {MediaMatcher} from "@angular/cdk/layout";
import {MatSidenav} from "@angular/material/sidenav";
import {AuthService} from "./core/auth/auth.service";
import packageJson from 'package.json';

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.scss']
})
export class AppComponent implements OnInit {

  userRoles: string[] | null = [];
  version: string | null = 'x';

  constructor(public authService: AuthService) {
    this.userRoles = this.authService.getUserRole();
  }

  ngOnInit() {
    // Subscribe to the userRole$ observable to get dynamic updates on user role changes
    this.authService.userRole$.subscribe((role) => {
      this.userRoles = role;
    });
    this.version = packageJson.version;
  }



  closeSidebar(sidenav: MatSidenav) {
    sidenav.close().then(r => {
    });
  }

  ngOnDestroy(): void {

  }

  onLogout(): void {
    this.authService.logout();
    this.userRoles = [];
  }

  loggedIn(): boolean {
    return this.authService.isLoggedIn();
  }

  showItem(requiredRole: string): boolean {
    if (this.userRoles) {
      return <boolean>this.userRoles!.includes(requiredRole);
    } else {
      this.userRoles = this.authService.getUserRole();
      return <boolean>this.userRoles!.includes(requiredRole);
    }
  }
}
